import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Chip,
  Grid,
  FormControlLabel,
  Switch,
  FormLabel,
} from '@material-ui/core';
import { Archive, FilterList, Edit } from '@material-ui/icons';
// import FilterListIcon from '@material-ui/icons/FilterList';

import PropTypes from 'prop-types';

import { complementaryColor } from '../../utils/constants';
import translations from '../../languages/i18n';
import fieldStyles from '../../styles/fieldStyles';

const BlueSwitch = withStyles({
  switchBase: {
    color: 'default',
    '&$checked': {
      color: complementaryColor,
    },
    '&$checked + $track': {
      backgroundColor: complementaryColor,
    },
  },
  checked: {},
  track: {},
})(Switch);
export default function EndedEnrolmentsFilter(props) {
  const {
    filterEnded, setFilterEnded, disabled
  } = props;

  const i18nTimeOutText = translations['_days'];
  const i18nLabel = translations['_timedOut'];
  const classesField = fieldStyles();

  return (
    <div>
      <Grid container direction='row' alignItems='center'>
        <Grid item>
          <div style={{ alignItems: 'center' }}>
            {/* <FormLabel className={classesField.formLabel}>XXX{translations['_actives']}</FormLabel> */}
            <FormControlLabel
              control={(
                <BlueSwitch
                  checked={filterEnded}
                  disabled={disabled}
                  onChange={(event) => setFilterEnded(event.target.checked)}
                  name='filterEnded'
                  color='primary'
                />
              )}
              // label={i18nLabel}
              // label="Manolo"
              label={<FilterList style={{ verticalAlign: 'middle'}}/>}
              className={classesField.formControlLabel}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

EndedEnrolmentsFilter.propTypes = {
  disabled: PropTypes.bool.isRequired,
  filterEnded: PropTypes.bool.isRequired,
  setFilterEnded: PropTypes.func.isRequired
};
